import Navbar from './Navbar';

function WhyThisAddon(){

    return(
        <div id="why-this-app" className='whyThisAppContainer'>
            <div className='whyThisAppWrapper'>
                <div className='contentDiv'>
                    <div className='containerDiv'>
                        <div className='title'>
                            <div className='main'>Why use this PDF to Google Sheets converter</div>
                            <div className='sub'>(<p style={{display: 'inline'}}>Convert PDF tables without leaving your spreadsheet</p>)</div>
                        </div>
                        <div className='content'>
                            <ul>
                                <li><p style={{display: 'inline'}}>Convert PDF to Google Sheets in 1 click, directly inside your spreadsheet</p></li>
                                <li>Uses advanced AI model for accurate table extraction</li>
                                <li>Preserves columns, rows and layout</li>
                                <li>No data stored permanently - full privacy</li>
                                <li>Responsive support in case of any queries or assistance</li>
                                <li>Reasonable pricing</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WhyThisAddon;